@if (getIcon()) {
<span class="ngx-data-table__icon">
@switch (col.icon) {
  @case ('inactive') {
  <ng-container>
    <mat-icon class="ngx-data-table__inactive" title="Inactive Customer">person_outline</mat-icon>
  </ng-container>
  }

  @case ('caresProspect') {
  <ng-container>
    <mat-icon title="CARES Prospect">face</mat-icon>
  </ng-container>
  }

}</span>
}
<span
      [ngClass]="{'mobile-data-table__title': (isMobile && col.mobile === 'title'),
                  'mobile-data-table__subtext': (isMobile && col.mobile === 'subtext')}">
  @if (isMobile && mobileTitle) {
  <span [ngClass]="{'ngx-data-table__bold': mobileTitleBold}">{{mobileTitle}}</span>
  }
@switch (col.type) {
  @case ('MonthDay') {
  <ng-container>{{getData() | locTimeZoneDate:'MMMM DD'}}</ng-container>
  }
  @case ('UTCLongMonthDay') {
  <ng-container>{{getData() | locTimeZoneDate:'MMMM DD'}}</ng-container>
  }
  @case ('UTCDate') {
  <ng-container>{{getData() | locTimeZoneDate:'MMM DD, YYYY'}}</ng-container>
  }
  @case ('Date') {
  <ng-container>{{getData() | locTimeZoneDate:'MMM DD, YYYY'}}</ng-container>
  }
  @case ('DayDate') {
  <ng-container>{{getData() | locTimeZoneDate:'MMM DD, YYYY'}}</ng-container>
  }
  @case ('DateTime') {
  <ng-container>
    @if (getData()) {
    <ng-container>
      {{getData() | locTimeZoneDate:'MMM DD, YYYY hh:mm A'}}
    </ng-container>
    }
    @if (!getData()) {
    <ng-container>
      N/A
    </ng-container>
    }
  </ng-container>
  }
  @case ('DayDateTime') {
  <ng-container>
    {{getData() | locTimeZoneDate:'ddd, MMM DD YYYY hh:mm A':getLocTimezone()}}
  </ng-container>
  }
  @case ('number') {
  <ng-container>
    {{getNumber() | number: '0.0-0'}}
  </ng-container>
  }
  @case ('comma') {
  <ng-container>
    {{getNumber().toLocaleString()}}
  </ng-container>
  }
  @case ('currency') {
  <ng-container>
    {{getNumber() | currency:'USD':'symbol':'1.2-2'}}
  </ng-container>
  }

  @case ('percentage') {
  <ng-container>
    {{getNumber() | percent: '1.2-2'}}
  </ng-container>
  }

  @case ('roundedPercentage') {
  <ng-container>
    {{getNumber() | percent: '1.0-0'}}
  </ng-container>
  }

  @case ('truncate') {
  <ng-container>
    {{getData() | myTruncate: col.truncateLength}}
  </ng-container>
  }

  @case ('html') {
  <ng-container>
    @if (!useFullMobileTable) {
    <div [innerHTML]="getData()"></div>
    }
    @if (useFullMobileTable) {
    <div [innerHTML]="getShortenedData(17)"></div>
    }
  </ng-container>
  }

  @case ('multi') {
  <ng-container>
    @if (col.topLabel) {
    <div>{{col.topLabel + ': ' + getTopPropData()}}</div>
    }
    @if (col.bottomLabel) {
    <div>{{col.bottomLabel + ': ' + getBottomPropData()}}</div>
    }
  </ng-container>
  }

  @case ('Status') {
  <div (mouseenter)="showHelpText()" (mouseleave)="hideHelpText()" (click)="$event.stopPropagation()" class="ngx-data-table__status-container" (keydown.enter)="$event.stopPropagation()">
    <img alt="Status Icon"
         class="ngx-data-table__status-icon"
         [src]="getStatusIcon()"/>
    <div [hidden]="!show"
         class="ngx-data-table__status-icon-info">
         <span [innerHTML]="getStatusIconInfo()"></span>
    </div>
  </div>
  }

  @case ('RecipientStatus') {
  <div class="ngx-data-table__recipient-status" [title]="getRecipientStatusDetail()">
    <img alt="" class="ngx-data-table__status-icon" [src]="getRecipientStatusIcon()"/>
    <span class="ngx-data-table__recipient-status-label">{{getRecipientStatusLabel()}}</span>
  </div>
  }

  @case ('address') {
  <ng-container>
    @if (getData()) {
    <div>
      {{getData().streetAddress}}
      <br>
      @if (hasSecondStreetAddress(getData().streetAddress2)) {
      <span>
        {{getData().streetAddress2}}
        <br>
      </span>
      }
      {{getData().locality}}, {{getData().region}}, {{getData().postalCode}}
    </div>
    }
  </ng-container>
  }

  @case ('membership') {
  <ng-container>
    <member-status [membership]="getData()"
                   [displayCfaOne]="getDisplayCfaOne()"
                   [isEnableSignatureMembership]="isEnableSignatureMembership"
                   [shouldDisplayIcon]="shouldDisplayIcon"
                   [shouldDisplayLabel]="shouldDisplayLabel"
                   [shouldDisplayMemberText]="shouldDisplayMemberText"
                   [isMobile]="isMobile">
    </member-status>
  </ng-container>
  }
   @case ('redFlag') {
   <ng-container>
    <div (mouseenter)="showHelpText()" (mouseleave)="hideHelpText()" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()">
      @if (getData() && !getDataBlackListed()) {
      <div>
        <img alt="Red Flag Icon"
             class="ngx-data-table__red-flag-icon"
             src="https://www.cfacdn.com/img/Spotlight/Icons/3P_Promotions_RedFlag.png" >
        <div [hidden]=" !show"
             fxLayout="column"
             fxLayoutAlign="start start"
             class="ngx-data-table__hover-text">
              <div class="ngx-data-table__block-text">This Customer has requested more than the set threshold for digital refunds.</div>
        </div>
      </div>
      }
      @if (getDataBlackListed()) {
      <div>
         <img alt="Red Flag Icon"
              class="ngx-data-table__red-flag-limit-icon"
              src="https://www.cfacdn.com/img/Spotlight/Icons/redFlagQuarterlyLimit.png" >
         <div [hidden]="!show"
             fxLayout="column"
             fxLayoutAlign="start start"
             class="ngx-data-table__hover-text">
              <div class="ngx-data-table__block-text">This customer has reached the maximum number of Digital Recovery requests and can no longer use the functionality</div>
         </div>
      </div>
      }
    </div>
  </ng-container>
   }
  @case ('ArrayList') {
  <ng-container>
    <app-read-more [displayString]="getDataArrayToList()" [isMobile]=useFullMobileTable></app-read-more>
  </ng-container>
  }

  @case ('offertype') {
  <ng-container>
    <offer-type [offerType]="getData()" [displaySnapIn]="getDisplayIcon()"></offer-type>
  </ng-container>
  }

  @case ('forgot2ScanIcon') {
  <ng-container >
    @if (getDisplayForgot2Scan()) {
    <span [matTooltip]="f2sToolTipText"
          [matTooltipClass]="'ngx-data-table__f2s-tooltip'" >
      <img alt="Receipt Icon" class="ngx-data-table__f2s-icon" src="../../../../assets/img/F2S_Receipt_Icon.png"/>
    </span>
    }
  </ng-container>
  }

  @case ('indicateComments') {
  <ng-container>
    @if (!isMobile) {
      @if (trimData()) {
      <mat-icon title="Comment Available">mode_comment</mat-icon>
      }
    } @else {
      <ng-container *ngTemplateOutlet="templateMobile"></ng-container>
    }
  </ng-container>
  }

  @case ('subtitleWithLabel') {
  <ng-container>
    @if (isMobile) {
    <span class="mobile-data-table__subtitle">
      {{col.title}}: {{getData()}}
    </span>
    } @else {
      <ng-container *ngTemplateOutlet="templateDefault"></ng-container>
    }
  </ng-container>
  }

  @case ('visitDate') {
  <ng-container>
    <span class="mobile-data-table__subtitle">
       {{getData() || 'N/A'}}
    </span>
  </ng-container>
  }

  @case ('lastVisitDate') {
  <ng-container>
    @if (isMobile) {
    <span class="mobile-data-table__subtitle">
      {{col.title}} {{getData() || 'N/A'}}
    </span>
    }
    @if (!isMobile) {
    <span class="mobile-data-table__subtitle">
      {{getData() || 'N/A'}}
    </span>
    }
  </ng-container>
  }

  @case ('birthDate') {
  <ng-container>
    @if (isMobile) {
    <span class="mobile-data-table__subtitle">
      {{col.title}} {{getData() || 'N/A'}}
    </span>
    } @else {
      <ng-container *ngTemplateOutlet="templateDefault"></ng-container>
    }
  </ng-container>
  }

  @case ('visitDateTime') {
  <ng-container>
    @if (isMobile) {
    <span class="mobile-data-table__subtitle">
      {{col.title}}: {{getData() | locTimeZoneDate:'MMM DD, YYYY hh:mm A'}}
    </span>
    }
    @if (!isMobile) {
    <span class="mobile-data-table__subtitle">
      {{getData() | locTimeZoneDate:'MMM DD, YYYY hh:mm A'}}
    </span>
    }
  </ng-container>
  }

  @case ('reportReceivedDate') {
  <ng-container>
    @if (isMobile) {
    <span class="mobile-data-table__subtitle">
      {{getData() | locTimeZoneDate:'ddd, MMM DD YYYY hh:mm A'}}
    </span>
    }
    @if (!isMobile) {
    <span class="mobile-data-table__subtitle">
      {{getData() | locTimeZoneDate:'MMM DD, YYYY hh:mm A'}}
    </span>
    }
  </ng-container>
  }

  @case ('recoveredDate') {
  <ng-container>
    @if (isMobile) {
    <span class="mobile-data-table__subtitle">
      {{col.title}}: {{getData() | locTimeZoneDate:'MMM DD, YYYY hh:mm A'}}
    </span>
    }
    @if (!isMobile) {
    <span class="mobile-data-table__subtitle">
      {{getData() | locTimeZoneDate:'MMM DD, YYYY hh:mm A'}}
    </span>
    }
  </ng-container>
  }

  @case ('delete') {
  <ng-container>
    @if (!disableDeleteIcon) {
    <span>
      <button type="button" class="cfa-plain-button cfa-plain-button--inline" aria-label="Delete" (click)="$event.stopPropagation(); deleteClicked()"><img alt="" class="ngx-data-table__delete-icon"
           src="{{deleteIconUrl}}"
          ></button>
    </span>
    }
  </ng-container>
  }

  @case ('remove') {
  <ng-container>
    @if (!getPreventDeletion()) {
    <button type="button" class="cfa-plain-button cfa-plain-button--inline" aria-label="Remove" (click)="$event.stopPropagation(); deleteClicked()"><mat-icon
              class="ngx-data-table__delete-icon"
             >
      clear
    </mat-icon></button>
    }
  </ng-container>
  }

  @case ('button') {
  <ng-container>
    <button mat-raised-button
            class="ngx-data-table__button"
            [attr.data-testid]="getText() + '-button'"
            [disabled]="shouldDisableButton"
            (click)="$event.stopPropagation(); buttonClicked()">
      {{getText()}}
    </button>
  </ng-container>
  }

  @case ('syncReport') {
  <ng-container>
    <div class="ngx-data-table__sync-report-container">
      <button mat-raised-button
              class="ngx-data-table__sync-report"
              [ngClass]="{'ngx-data-table__sync-report-red-button' : row && row.lastReportDateTime}"
              [attr.data-testid]="getText() + getConcatData() + '-button'"
              (click)="$event.stopPropagation(); externalLinkClicked()">
        View Report
      </button>
      @if (row && row.lastReportDateTime) {
      <help-text
                class="ngx-data-table__follow-up-help-text"
                [displayAbove]="true"
                [displayInCenter]="true"
                [displayRedText]="true"
                [helpText]="'A follow-up report has been submitted'"
                [icon]="'error_outline'">
      </help-text>
      }
</div>
   
  </ng-container>
  }

  @case ('memberProfile') {
  <ng-container>
    @if (showMemberProfile()) {
    <button
            mat-raised-button
            class="ngx-data-table__member-profile"
            [attr.data-testid]="getText() + '-button'"
            (click)="$event.stopPropagation(); buttonClicked()">
      {{getText()}}
    </button>
    }
  </ng-container>
  }

  @case ('conditionalExternalLink') {
  <ng-container>
    @if (getData()) {
    <a class="ngx-data-table__link"
       (click)="$event.stopPropagation(); externalLinkClicked()">
      {{getText()}}
    </a>
    }
    @if (!getData()) {
    <div>N/A</div>
    }
  </ng-container>
  }

  @case ('defaultNA') {
  <ng-container>
    @if (getData()) {
    <span>{{getData()}}</span>
    }
    @if (!getData()) {
    <span>N/A</span>
    }
  </ng-container>
  }

  @case ('viewNotes') {
  <ng-container>
    @if (getViewNotesData()) {
    <button type="button"
          class="ngx-data-table__view-notes cfa-plain-button cfa-plain-button--inline"
          (click)="$event.stopPropagation(); viewNotesClicked()"
         >
      {{getViewNotesLabel()}}
    </button>
    }
    @if (!getViewNotesData()) {
    <span>N/A</span>
    }
  </ng-container>
  }

  @case ('dateOfReport') {
  <ng-container>
    {{getDate() | locTimeZoneDate:'MMM DD, YYYY hh:mm A':col.showTimezone}}
  </ng-container>
  }

  @case ('refundReasons') {
  <ng-container>
    <span [innerHtml]="getRefundReasons()"></span>
  </ng-container>
  }

  @case ('orderNumber') {
  <ng-container>
    @if (getData()) {
    <div>
      @if (getOrderNumberSelectable()) {
      <button type="button"
           fxLayout="row"
           fxLayoutAlign="center center"
           class="ngx-data-table__order-link cfa-plain-button"
           (click)="$event.stopPropagation(); orderNumberClicked()"
          >
        {{getData()}}
      </button>
      }
      @if (!getOrderNumberSelectable()) {
      <div
           class="ngx-data-table__order-nonselectable">
        {{getData()}}
      </div>
      }
    </div>
    }
    @if (!getData()) {
    <div></div>
    }
  </ng-container>
  }

  @default {
  <ng-container>
    @if (isMobile) {
      <ng-container *ngTemplateOutlet="templateMobile"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="templateDefault"></ng-container>
    }
  </ng-container>
  }
}

  <ng-template #templateMobile>
    <span class="truncated">{{getData() | myTruncate: getTruncateLimit()}}</span>
  </ng-template>

  <ng-template #templateDefault>
    <div [ngClass]="{'ngx-data-table__basic-cell': !col.icon, 'ngx-data-table__basic-cell-with-icon': col.icon}">
      @if (!useFullMobileTable) {
      <span>{{getData()}}</span>
      }
      @if (useFullMobileTable) {
      <span>{{getShortenedData(7)}}</span>
      }
    </div>
  </ng-template>
</span>
